<template>
  <div class="monitoring-cabin-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" title="新增" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" title="编辑" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="showAuthDialog" size="mini"
                     type="primary" icon="el-icon-s-tools">设置基站
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="分站编码">123</el-table-column>
        <el-table-column label="分站名称"></el-table-column>
        <el-table-column label="所属甲板"></el-table-column>
        <el-table-column label="基站设置">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain>已设置</el-button>
            <!--<el-button size="mini">未设置</el-button>-->
          </template>
        </el-table-column>
        <!--<el-table-column label="基站数量">112个</el-table-column>-->
        <!--<el-table-column label="喇叭数量">112个</el-table-column>-->
        <!--<el-table-column label="传感器数量">112个</el-table-column>-->
        <!--<el-table-column label="声光报警器数量">112个</el-table-column>-->
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                     :current-page.sync="pagination.page"
                     :total="pagination.total" @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">分站名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">分站编码</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">甲板</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择甲板">
            <el-option
                v-for="item in [{value:'甲板1',label:'甲板1'},{value:'甲板2',label:'甲板2'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置基站，和前面“船舱总段”一样" width="800px" :visible.sync="authDialogShow">
      <div class="auth-box">
        <div class="item" :class="item.active?'active':''" @click="setActive(index)"
             v-for="(item,index) in [1,2,3,4,5,6,7,8,9]" :key="index">
          <span class="zsf-icon check"
                :class="item.active?'zsf-icon-yixuanze- color-409eff':'zsf-icon-weixuanze-1 color-dcdcdc'"></span>
          <span class="width-100 t-hidden"
                :class="item.pid===0?'pl-10 font-bold':'pl-30'">基站编号</span>
          <span class="width-150 color-999 ml-10">基站名称</span>
          <span class="color-999 ml-10">其他字段</span>
        </div>
      </div>
      <div class="pagination pt-10 t-center mt-10">
        <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                       :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                       :current-page.sync="pagination.page"
                       :total="pagination.total"
                       @size-change="changeSize"
                       @current-change="changeCurrent"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="authDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAuth">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false,
        authDialogShow: false
      };
    },

    computed: {},

    created() {
      this.getData();
    },

    methods: {
      submitAuth(){
      },
      showAuthDialog() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.authDialogShow = true;
      },
      setActive(index) {
        //console.log(index);
        //console.log(this.authList[index]);
        let roleAuthList = [...this.authList];
        console.log(roleAuthList[index]["pid"]);
        //roleAuthList[index]['active'] = !roleAuthList[index]['active'];
        if (roleAuthList[index]["pid"] === 0) {
          console.log(roleAuthList[index].id);
          if (roleAuthList[index]["active"]) {
            roleAuthList[index]["active"] = false;
            for (let i = 0; i < roleAuthList.length; i++) {
              if (roleAuthList[i]["pid"] === roleAuthList[index].id) {
                roleAuthList[i].active = false;
              }
            }
          } else {
            roleAuthList[index]["active"] = true;
            for (let i = 0; i < roleAuthList.length; i++) {
              if (roleAuthList[i]["pid"] === roleAuthList[index].id) {
                roleAuthList[i].active = true;
              }
            }
          }
        } else {
          roleAuthList[index]["active"] = !roleAuthList[index]["active"];
          for (let i = 0; i < roleAuthList.length; i++) {
            if (roleAuthList[i]["id"] === roleAuthList[index].pid) {
              roleAuthList[i].active = true;
            }
          }
        }
        this.roleAuthList = roleAuthList;
        console.log(this.roleAuthList);
      },
      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },
      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },
      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        this.tableLoading = false;
        this.pagination.total = 222;
        this.list = [
          {id: 1},
          {id: 2},
          {id: 3},
          {id: 4},
          {id: 5},
          {id: 6},
          {id: 7},
          {id: 8},
          {id: 9},
          {id: 10}
        ];
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .monitoring-cabin-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
